import { formJson, formVal } from './config';

export default {
  name: 'FcFormBuild',
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      default: () => formJson,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outputString: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => formVal,
    },
  },
  created() {
  },
  methods: {
    getData() {
      // 提交函数，提供父级组件调用
      return this.$refs.formBuildRef.getData();
    },
  },
  render() {
    const { value, disabled, defaultValue } = this;
    return (
      <div>
      </div>
    );
  },
};
